import { Block, DomainTypes } from '@/types';
import { Homepage } from '@/types/homepage';
import { Langs } from '@/types/lang';

import { BlockEntity } from './BlockEntity';

export class HomePageEntity {
  source: DomainTypes;
  domain: string;
  UUID?: string;
  lang?: Langs;
  updateAt?: number;
  blocks: Block[];
  hash?: string;
  title: string;
  isDefault: boolean;

  constructor(homepage: Partial<Homepage>) {
    this.source = homepage.source || DomainTypes.Internal;
    this.domain = homepage.domain;
    this.UUID = homepage.UUID;
    this.lang = homepage.lang || Langs.Fr;
    this.updateAt = homepage.updateAt || Date.now();
    this.blocks = (homepage.blocks || []).map((block) => new BlockEntity(block));
    this.hash = homepage.hash || 'HASH';
    this.title = homepage.title || 'HOMEPAGE_TITLE';
    this.isDefault = homepage.isDefault || false;
  }
}
